/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { LocationField, InfoItem, RelatedContentModal } from '@molecules';
import { NO_MARGIN_BOTTOM } from '@constants';

const RelatedLocationModal = ({ visible, hide, onSubmit }) => (
  <RelatedContentModal
    visible={visible}
    hide={hide}
    title="Add related location"
    subtitle="Find a location related to this article"
    okText="ADD LOCATION"
    onSubmit={({ location }) => onSubmit(location)}
  >
    <LocationField
      label="Choose a location"
      name="location"
      extra={null}
      wrapperCol={{ span: 24 }}
      style={NO_MARGIN_BOTTOM}
      rules={[{ required: true, message: 'Location is required' }]}
    />
  </RelatedContentModal>
);

const Item = (location) => <InfoItem>{location.name}</InfoItem>;

RelatedLocationModal.Item = Item;

export default RelatedLocationModal;
